export class GpsTracker {
    static isIconPrecomposed = true;
    static geoLocater = null;
    static requiredSyncLvl = 2;
    static heightAngle = {
        min: -20,
        max: 20
    }
    static mapLoaded = false;
    static altitudeSyncService = null;
    static sumDistance = 0;
    static avgSpeed = 0;
    static maxSpeed = 0;
    static currentSpeed = "0";
    static isGPS: boolean = true;
    static isBackground: boolean = false;
    static isRunning: boolean = false;
    static lastAltitude = 0;
    static altitudeGainPerKm = 0;
    static altitudeLossPerKm = 0;

    static formatTime(seconds, formatKey, lang) {
        const months = lang.includes('de') ? [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ] : [
            "Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
        ];

        const daysOfWeek = lang.includes("de") ? [
            "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"
        ] : [
            "So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"
        ];

        const date = new Date(seconds);
        const localHours = date.getHours();
        const localMinutes = date.getMinutes();
        const localSeconds = date.getSeconds();
        const localTime = localHours + ":" + (localMinutes < 10 ? '0' : '') + localMinutes + ":" + (localSeconds < 10 ? '0' : '') + localSeconds;
        console.log(localTime)

        switch (formatKey) {
            case "dd.MM.yyyy":
                return `${("0" + date.getDate()).slice(-2)}.${("0" + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()} ${localTime}`;
            case "dd.MM.yy":
                return `${("0" + date.getDate()).slice(-2)}.${("0" + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear().toString().slice(-2)} ${localTime}`;
            case "MM/dd/yyyy":
                return `${("0" + (date.getMonth() + 1)).slice(-2)}/${("0" + date.getDate()).slice(-2)}/${date.getFullYear()} ${localTime}`;
            case "MM/dd/yy":
                return `${("0" + (date.getMonth() + 1)).slice(-2)}/${("0" + date.getDate()).slice(-2)}/${date.getFullYear().toString().slice(-2)} ${localTime}`;
            case "dd-MMM-yyyy":
                return `${("0" + date.getDate()).slice(-2)}-${months[date.getMonth()]}-${date.getFullYear()} ${localTime}`;
            case "dd-MMM-yy":
                return `${("0" + date.getDate()).slice(-2)}-${months[date.getMonth()]}-${date.getFullYear().toString().slice(-2)} ${localTime}`;
            case "E,_dd_MMM_yyyy":
                return `${daysOfWeek[date.getDay()]}, ${("0" + date.getDate()).slice(-2)} ${months[date.getMonth()]} ${date.getFullYear()} ${localTime}`;
            default:
                return "Invalid format key";
        }
    }

}


// WEBPACK FOOTER //
// /src/tracker/gps-tracker.ts